import React, { Component } from 'react'
import { connect } from 'react-redux';
import classnames from 'classnames';

import { profileInvalidate, profileFetchIfNeeded } from "../../store/profile/actions";

import EssayTechnologiesBusiness from './EssayTechnologiesBusiness';
import EssayPhilosophy from './EssayPhilosophy';
import EssayNationalPark from './EssayNationalPark';
import EssayLinearRegression from './EssayLinearRegression';
import EssayGeneralChemistry from './EssayGeneralChemistry';
import EssayGenderInMedia from './EssayGenderInMedia';
import EssayDiscussion7 from './EssayDiscussion7';
import EssayHealthcare from './EssayHealthcare';
import EssaySoftwareProject from './EssaySoftwareProject';
import EssayResearchArgumentative from './EssayResearchArgumentative';
import { profileUpdateStages } from "../../store/profile/actions";

import baseStyles from 'custom/base.styl';
import styles from './../../styles/perfect_essay.styl';


const essays = {
  HUMANITIES: EssayPhilosophy,
  'HEALTHCARE AND NURSING': EssayHealthcare,
  MATHEMATICS: EssayLinearRegression,
  FINANCE: EssaySoftwareProject,
  SOCIOLOGY: EssayGenderInMedia,
  CHEMISTRY: EssayGeneralChemistry,
  'BUSINESS STUDIES': EssayResearchArgumentative,
  GEOGRAPHY: EssayNationalPark,
  'BUSINESS AND MANAGEMENT': EssayTechnologiesBusiness,
  'POLITICAL SCIENCE': EssayDiscussion7,
};

class PagePerfectEssay extends Component {
  componentDidMount() {
    const { load } = this.props;
    load();
  }

  onStageNext() {
    const { nextStage } = this.props;
    nextStage();
    return;
  }

  render() {
    const { subject } = this.props;
    const EssayComponent = essays[subject];

    if (!EssayComponent) {
      setTimeout(() => {
        this.onStageNext();
      }, 1000);
      return null;
    }

    let inlineStyles = {};

    switch (subject) {
      case 'HEALTHCARE AND NURSING':
      case 'CHEMISTRY':
        inlineStyles = { minHeight: '1200px' }
        break;

      case 'BUSINESS STUDIES':
        inlineStyles = { minHeight: '1600px' }
        break;

      default:
        inlineStyles = { minHeight: '800px' }
        break;
    }

    return (
      <div>
        <div className={styles.essay_container}>
          <div className={classnames(baseStyles.text_success, baseStyles.text_middle, baseStyles.space_bottom)}>
            <b>Now,  have a look at a perfect sample our experts prepared for you.</b>
          </div>
          <p className={classnames(baseStyles.title_extra_small)}>
            Please, be attentive to all the tips as they will help you with your further orders!
          </p>
          <br />
        </div>
        <div className={styles.perfect_essay_wrap} style={inlineStyles}>
          <div className={styles.perfect_essay_scale}>
            <EssayComponent />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const tasks = state.profile && state.profile.data && state.profile.data.user && state.profile.data.user.active_tasks;
  const subject = tasks && tasks[0] && tasks[0].task && tasks[0].task.data && tasks[0].task.data.subject;
  return { subject };
};

const mapDispatchToProps = dispatch => ({
  load: () => {
    dispatch(profileInvalidate());
    dispatch(profileFetchIfNeeded());
  },
  nextStage: () => dispatch(profileUpdateStages()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PagePerfectEssay);



// WEBPACK FOOTER //
// ./src/components/PerfectEssay/PagePerfectEssay.js